import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ltcs-request-confirm" }
const _hoisted_2 = { class: "ltcs-request-confirm__header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "ltcs-request-confirm__body" }
const _hoisted_5 = { class: "param-list" }
const _hoisted_6 = { class: "param-row" }
const _hoisted_7 = {
  key: 0,
  class: "param-row"
}
const _hoisted_8 = { class: "param-row param-row--emphasis" }
const _hoisted_9 = { class: "ym-label" }
const _hoisted_10 = {
  class: "ym-code",
  title: "서버로 전송되는 연월 값"
}
const _hoisted_11 = { class: "param-row" }
const _hoisted_12 = {
  key: 2,
  class: "param-row"
}
const _hoisted_13 = { class: "ltcs-request-confirm__actions" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsRequestConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    typeName: { default: '' },
    yearMonth: { default: '' },
    bizGubun: { default: '' },
    facilityName: { default: '' },
    needsYearMonth: { type: Boolean, default: true },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const yearMonthLabel = computed(() => {
  const ym = props.yearMonth || '';
  if (ym.length !== 6) return ym || '-';
  return `${ym.slice(0, 4)}년 ${parseInt(ym.slice(4, 6), 10)}월`;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "440",
    persistent: "",
    "z-index": 10200,
    "content-class": "ltcs-request-confirm-dialog",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, {
            size: "22",
            color: "#1e3a5f"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("mdi-send-check", -1)
            ]))]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createElementVNode("h3", null, "자료요청 확인", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "ltcs-request-confirm__close",
            "aria-label": "닫기",
            disabled: __props.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "confirm-lead" }, "아래 조건으로 롱텀케어에 요청합니다. 연월이 맞는지 확인해 주세요.", -1)),
          _createElementVNode("dl", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("dt", null, "요청 유형", -1)),
              _createElementVNode("dd", null, _toDisplayString(__props.typeName || '-'), 1)
            ]),
            (__props.facilityName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("dt", null, "시설명", -1)),
                  _createElementVNode("dd", null, _toDisplayString(__props.facilityName), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.needsYearMonth)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[9] || (_cache[9] = _createElementVNode("dt", null, "조회 연월", -1)),
                    _createElementVNode("dd", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(yearMonthLabel.value), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(__props.yearMonth || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("dt", null, "사업구분", -1)),
                    _createElementVNode("dd", null, _toDisplayString(__props.bizGubun || '미선택'), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("dt", null, "조회 연월", -1),
                  _createElementVNode("dd", { class: "muted" }, "해당 없음 (전체 조회)", -1)
                ]))]))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-cancel",
            disabled: __props.loading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode(" 취소 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-register",
            loading: __props.loading,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "16",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("mdi-send", -1)
                ]))]),
                _: 1
              }),
              _cache[15] || (_cache[15] = _createTextVNode(" 요청 보내기 ", -1))
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})